import * as Animate from "react-reveal";
import Image1 from "../../../assets/images/png/impact/impact3.webp";
import Image2 from "../../../assets/images/png/mba/mba-leader-man-v1.png";
import Image3 from "../../../assets/images/png/mba/mba-leader-woman-v1.png";
import Image4 from "../../../assets/images/png/mba/mba-leader-hijab-v1.png";
import NetworkPhoto from "../../../assets/images/png/c.png";
import { ArrowUpRight } from "../../../components/svgs";

const talent = [
  {
    img: Image1,
    location: "Nigeria",
    experience: "6 years experience",
    title: "Senior Software Engineer",
    checks: [
      "Engineering",
      "Project Evidence",
      "Communication",
      "Client Readiness",
    ],
  },
  {
    img: Image3,
    location: "Kenya",
    experience: "5 years experience",
    title: "AI / ML Engineer",
    checks: [
      "Machine Learning",
      "Applied AI",
      "Communication",
      "Work Readiness",
    ],
  },
  {
    img: Image4,
    location: "Ghana",
    experience: "7 years experience",
    title: "Data Engineer",
    checks: [
      "Data Systems",
      "Project Evidence",
      "Communication",
      "Client Readiness",
    ],
  },
  {
    img: Image2,
    location: "South Africa",
    experience: "8 years experience",
    title: "Product Manager",
    checks: ["Product Strategy", "Delivery", "Communication", "Leadership"],
  },
];

const HireTalentGridSection = () => {
  return (
    <section
      className="bg-white py-16 md:py-20 lg:py-24 px-4"
      id="talent-network"
    >
      <Animate.Fade bottom>
        <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6 container mx-auto">
          <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
          The Utiva talent network
        </p>
      </Animate.Fade>

      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-hire-network items-end gap-8 lg:gap-11 mb-8 lg:mb-9">
          <div>
            <Animate.Fade bottom>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight text-primary font-bold tracking-[-0.03em] mb-6">
                Already Developed. Already Assessed.{" "}
                <span className="text-primary">
                  Ready for the Right Company.
                </span>
              </h2>
            </Animate.Fade>
            <Animate.Fade bottom>
              <p className="text-gray text-base md:text-lg font-poppins leading-relaxed">
                Representative professionals from a much larger network of
                technology and business talent.
              </p>
            </Animate.Fade>
          </div>

          <Animate.Fade bottom>
            <div className="relative rounded-3xl overflow-hidden min-h-[390px]">
              <img
                src={NetworkPhoto}
                alt="Work-ready Utiva professionals collaborating"
                className="w-full h-full object-cover absolute inset-0"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#030447e6]"></div>
              <div className="z-[1] border-l-4 border-secondary text-white bg-primary backdrop-blur-md rounded-r-xl max-w-[310px] px-5 py-4 absolute bottom-5 left-5">
                <strong className="text-secondary font-poppins text-3xl leading-none block">
                  20,000+
                </strong>
                <span className="text-sm leading-snug block mt-1.5">
                  professionals across technology and business
                </span>
              </div>
            </div>
          </Animate.Fade>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {talent.map((person) => (
            <Animate.Fade bottom key={person.title + person.location}>
              <article className="border border-hire-line rounded-3xl overflow-hidden h-full flex flex-col">
                <div className="relative bg-hire-tint-blue h-64 overflow-hidden">
                  <img
                    src={person.img}
                    alt={`${person.title} in the Utiva talent network`}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className="absolute bottom-3.5 left-3.5 bg-secondary text-primary rounded-full px-2.5 py-1.5 text-xs font-poppins font-extrabold">
                    REMOTE READY
                  </span>
                </div>

                <div className="p-5 flex flex-col flex-1">
                  <p className="text-gray font-poppins text-xs font-bold mb-2">
                    {person.location} · {person.experience}
                  </p>
                  <h3 className="text-primary font-poppins font-bold text-xl mb-4 min-h-[3.5rem]">
                    {person.title}
                  </h3>

                  <div className="grid gap-2 mb-5">
                    {person.checks.map((check) => (
                      <span
                        key={check}
                        className="text-gray font-poppins text-xs"
                      >
                        {check} ✓
                      </span>
                    ))}
                  </div>

                  <a
                    href="https://app.utiva.co/signup?goal=employer"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="mt-auto pt-4 border-t border-hire-line text-primary font-poppins font-extrabold text-sm flex items-center justify-between"
                  >
                    View Talent
                    <ArrowUpRight className="w-3 h-3 inline-block" />
                  </a>
                </div>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HireTalentGridSection;
